import React, { useEffect, useState } from "react";
import { Input, Button, Select, DatePicker, Spin , TreeSelect } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

import orderService from "../../services/OrderLists";

const { Option } = Select;
const { RangePicker } = DatePicker;

const SearchFilters = ({
  onSearch,
  pagination,
  loadOrders,
  statusList,
  filtersList,
  fetchingStatusList,
  subscribers,
  setSubscribers,
  salesTeamOptions,
  ownerShipList,
  setOwnerShipList,
  treeData,
  situationsList,
}) => {
  const isMobile = useIsMobile();
  // const initialFilters = filtersList.reduce((acc, filter) => {
  //   acc[filter] = "";
  //   return acc;
  // }, {});

  // const initialFilters = filtersList.reduce((acc, filter) => {
  //   acc[filter] = filter === "moved_to_fl" ? undefined : "";
  //   return acc;
  // }, {});

  const [filters, setFilters] = useState({
    key: "",
    payment_status: "",
    status: "",
    title: "",
    deadline_hard: null,
    allotted_deadline: null,
    client_deadline_start: null,
    subscriber: [],
    moved_to_fl: null,
    client_deadline_end: null,
    sales_team: [],
    client_username: "",
    ownership: "",
    order_start_date_from: "",
    order_start_date_to: "",
    tags: [],
    situation: "",
  });

  const handleSearch = () => {
    const formattedFilters = Object.keys(filters).reduce((acc, key) => {
      if (filters[key]) {
        if (
          key === "deadline_hard" ||
          key === "allotted_deadline" ||
          key === "client_deadline" ||
          filters[key]._isAMomentObject
        ) {
          acc[key] = dayjs(filters[key]).format("YYYY-MM-DD");
        } else if (key === "subscriber" && filters[key].length > 0) {
          acc[key] = filters[key].join(",");
        } else if (key === "tags" && filters[key].length > 0) {
          acc[key] = filters[key];
        } else if (key !== "subscriber" && key !== "tags") {
          acc[key] = filters[key];
        }
      }
      return acc;
    }, {});

    onSearch(formattedFilters);
  };

  const handleFilterChange = (key, value) => {
  console.log(value);
  if (key === "sales_team") {
    const cleaned = Array.isArray(value)
      ? value.map((item) => (item?.value ? item.value : item))
      : [];
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: cleaned,
    }));
  } else {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  }
};

  const handleCancel = async () => {
    // const resetFilters = Object.keys(filters).reduce((acc, filter) => {
    //   if (filter === "subscriber") {
    //     acc[filter] = []; // Explicitly reset to empty array
    //   } else {
    //     acc[filter] = filter === "moved_to_fl" ? undefined : "";
    //   }
    //   return acc;
    // }, {});

    // setFilters(resetFilters); // Reset all filters
    setFilters({
      key: "",
      payment_status: "",
      status: "",
      title: "",
      deadline_hard: null,
      allotted_deadline: null,
      client_deadline: null,
      subscriber: [],
      moved_to_fl: null,
      sales_team: [],
      client_username: "",
      order_start_date_from: "",
      order_start_date_to: "",
      tags: [],
      situation: "",
    });
    await loadOrders(); // Reload orders after resetting filters
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const renderFilter = (filter) => {
    // Default filter configuration
    const defaultConfig = {
      component: Input,
      props: {
        placeholder: `Filter by ${filter
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}`,
        style: { width: isMobile ? "80vw" : 300 },
        value: filters[filter],
        onChange: (e) => handleFilterChange(filter, e.target.value),
        onKeyDown: handleKeyDown,
      },
    };

    // Special case configurations
    const filterConfigs = {
      key: {
        component: Input,
        props: {
          placeholder: "Filter by Key",
          style: { width: isMobile ? "80vw" : 300 },
          value: filters.key,
          onChange: (e) => handleFilterChange("key", e.target.value),
          onKeyDown: handleKeyDown,
        },
      },
      payment_status: {
        component: Select,
        props: {
          placeholder: "Payment Status",
          style: {
            width: isMobile ? "80vw" : 300,
            textAlign: "left",
            position: "relative",
            left: isMobile ? "0" : "0px",
          },
          value: filters.payment_status || undefined,
          onChange: (value) => handleFilterChange("payment_status", value),
          onKeyDown: handleKeyDown,
        },
        options: [
          { value: "Paid", label: "Full" },
          { value: "Unpaid", label: "Unpaid" },
          { value: "Partial", label: "Partial" },
          { value: "Not_Updated", label: "Not Updated" },
        ],
      },
      status: {
        component: Select,
        props: {
          placeholder: "Status",
          style: {
            width: isMobile ? "80vw" : 300,
            textAlign: "left",
          },
          mode: "multiple",
          value: filters.status || undefined,
          onChange: (value) => handleFilterChange("status", value),
          showSearch: true, // Enable search
          optionFilterProp: "children", // Filter options by their label
          onKeyDown: handleKeyDown,
        },
        options: Object.entries(statusList || {}).map(([label, value]) => ({
          value: value.toString(),
          label,
        })),
      },
      title: {
        component: Input,
        props: {
          placeholder: "Filter by Title",
          style: { width: isMobile ? "80vw" : 300 },
          value: filters.title,
          onChange: (e) => handleFilterChange("title", e.target.value),
          onKeyDown: handleKeyDown,
        },
      },
      deadline_hard: {
        component: DatePicker,
        props: {
          style: { width: isMobile ? "80vw" : 300 },
          placeholder: "Filter by Deadline",
          value: filters.deadline_hard,
          onChange: (value) => handleFilterChange("deadline_hard", value),
        },
      },
      allotted_deadline: {
        component: DatePicker,
        props: {
          style: { width: isMobile ? "80vw" : 300 },
          placeholder: "Filter by Allotted Deadline",
          value: filters.allotted_deadline,
          onChange: (value) => handleFilterChange("allotted_deadline", value),
        },
      },
      client_deadline_start: {
        component: RangePicker,
        props: {
          style: { width: isMobile ? "80vw" : 300 },
          placeholder: ["Client Deadline Start Date", "Client Deadline End Date"],
          value: [
            filters.client_deadline_start
              ? dayjs(filters.client_deadline_start)
              : null,
            filters.client_deadline_end
              ? dayjs(filters.client_deadline_end)
              : null,
          ],
          onChange: (dates) => {
            if (!dates || dates.length === 0 || (!dates[0] && !dates[1])) {
              handleFilterChange("client_deadline_start", "");
              handleFilterChange("client_deadline_end", "");
            } else {
              handleFilterChange(
                "client_deadline_start",
                dates[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : ""
              );
              handleFilterChange(
                "client_deadline_end",
                dates[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : ""
              );
            }
          },
          allowClear: true,
        },
      },
      order_start_date_from: {
        component: RangePicker,
        props: {
          style: { width: isMobile ? "80vw" : 300 },
          placeholder: ["Order Start from", "Order Start to"],
          value: [
            filters.order_start_date_from
              ? dayjs(filters.order_start_date_from)
              : null,
            filters.order_start_date_to
              ? dayjs(filters.order_start_date_to)
              : null,
          ],
          onChange: (dates) => {
            if (!dates || dates.length === 0 || (!dates[0] && !dates[1])) {
              handleFilterChange("order_start_date_from", "");
              handleFilterChange("order_start_date_to", "");
            } else {
              handleFilterChange(
                "order_start_date_from",
                dates[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : ""
              );
              handleFilterChange(
                "order_start_date_to",
                dates[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : ""
              );
            }
          },
          allowClear: true,
        },
      },
      subscriber: {
        component: Select,
        props: {
          mode: "multiple",
          placeholder: "Filter By Subscribers",
          style: { width: isMobile ? "80vw" : 300, textAlign: "left" },
          value: filters.subscriber || [], // Ensure this is never undefined
          onChange: (value) => handleFilterChange("subscriber", value),
          optionFilterProp: "children",
          onKeyDown: handleKeyDown,
        },
        options: subscribers?.map((subscriber) => ({
          value: subscriber.id,
          label: subscriber.name,
        })),
      },

      moved_to_fl: {
        component: Select,
        props: {
          placeholder: "Moved to Fl",
          style: {
            width: isMobile ? "80vw" : 300,
            textAlign: "left",
            position: "relative",
            left: isMobile ? "0" : "0px",
          },
          value: filters.moved_to_fl,
          onChange: (value) => handleFilterChange("moved_to_fl", value),
          onKeyDown: handleKeyDown,
        },
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },

      sales_team: {
        component: TreeSelect,
        props: {
          placeholder: "Sales Team",
          style: {
            width: isMobile ? "80vw" : 300,
            textAlign: "left",
          },
          value: filters.sales_team || [], // ensure it's an array
          onKeyDown: handleKeyDown,
          onChange: (value) => {
            let selectedValues = Array.isArray(value)
              ? value.map((item) => item?.value ?? item)
              : [];
        
            if (selectedValues.includes("Total")) {
                const getAllUidsFromTree = (tree) => {
                    let uids = [];
                    for (const node of tree) {
                        if (node.value !== "Total") {
                            uids.push(node.value);
                        }
                        if (node.children?.length > 0) {
                            uids = uids.concat(getAllUidsFromTree(node.children));
                        }
                    }
                    return uids;
                };
                selectedValues = getAllUidsFromTree(treeData);
            }
        
            handleFilterChange("sales_team", selectedValues);
        }
,        
          showSearch: true,
          optionFilterProp: "children",
          treeData: treeData,
          treeCheckable: true,
          treeCheckStrictly: true, // Enable strict check
          showCheckedStrategy: TreeSelect.SHOW_PARENT,
          allowClear: true,
          multiple: true,
          filterTreeNode: (input, node) => {
            let label = "";
            if (typeof node.title === "string") {
              label = node.title;
            } else if (React.isValidElement(node.title)) {
              if (node.title.props && node.title.props.children) {
                if (Array.isArray(node.title.props.children)) {
                  label = node.title.props.children[0];
                } else {
                  label = node.title.props.children;
                }
              }
            }
            return label && label.toLowerCase().includes(input.toLowerCase());
          },
        },
        options: salesTeamOptions,
      },
      
      tags: {
        component: Select,
        props: {
          mode: "tags",
          placeholder: "Filter By Tags",
          style: { width: isMobile ? "80vw" : 300, textAlign: "left" },
          value: filters.tags || [],
          onChange: (value) => handleFilterChange("tags", value),
          tokenSeparators: [","],
          open: false,
          onKeyDown: handleKeyDown,
        },
      },

      ownership: {
        component: Select,
        props: {
          placeholder: "Filter By Ownership",
          style: { width: isMobile ? "80vw" : 300, textAlign: "left" },
          value: filters.ownership || undefined,
          onChange: (value) => handleFilterChange("ownership", value),
          showSearch: true,
          optionFilterProp: "children",
          allowClear: true,
          onKeyDown: handleKeyDown,
        },
        options:
          ownerShipList?.map((ownerShip) => ({
            value: ownerShip.email,
            label: ownerShip.user,
          })) || [],
      },

      situation: {
        component: Select,
        props: {
          placeholder: "Filter By Order Situation",
          style: { width: isMobile ? "80vw" : 300, textAlign: "left" },
          value: filters.situation || undefined,
          onChange: (value) => handleFilterChange("situation", value),
          showSearch: true,
          optionFilterProp: "children",
          allowClear: true,
          onKeyDown: handleKeyDown,
        },
        options:
          situationsList?.map((situation) => ({
            value: situation.id,
            label: situation.name,
          })) || [],
      },
      // ownership:{
      //   component: Select,
      //   props: {
      //     placeholder: "Ownership",
      //     style: {
      //       width: isMobile ? "80vw" : 300,
      //       textAlign: "left",
      //     },
      //     value: filters.ownership || [],
      //     onChange: (value) => handleFilterChange("ownership", value),
      //     showSearch: true,
      //     optionFilterProp: "children",
      //     allowClear: true,
      //   },
      //   options: ownershipOptions,
      // },
    };

    // Get the configuration for this filter, or use default
    const config = filterConfigs[filter] || defaultConfig;
    const Component = config.component;

    // For Select components with options
    if (config.options) {
      return (
        <Component {...config.props}>
          {config.options.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Component>
      );
    }

    // For other components
    return <Component {...config.props} />;
  };

  // console.log("filters_innnn",filters)
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{ background: "#eceff1", padding: "20px", borderRadius: "8px" }}>
        {fetchingStatusList ? (
          <Spin />
        ) : (
          <div
            style={{
              marginBottom: 16,
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              justifyContent: "space-between",
              alignItems: "flex-end",
              width: "100%",
            }}>
            {/* {console.log(filters.subscribers , '1234')} */}
            {filtersList
              .filter(
                (f) =>
                  f !== "client_deadline_end" && f !== "order_start_date_to"
              )
              .map((filter) => (
                <div key={filter} style={{ marginRight: 16 }}>
                  {renderFilter(filter)}
                </div>
              ))}
            {/* {console.log(filtersList , 'filterlist')} */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "flex-end",
                alignContent: "flex-end",
                alignItems: "flex-end",
                position: "relative",
                right: isMobile ? "0" : "10px",
                flexDirection: isMobile ? "column" : "row",
                width: "100%",
              }}>
              <Button
                type="primary"
                style={{
                  width: isMobile ? "80vw" : 140,
                  background: "#040724",
                }}
                icon={<SearchOutlined />}
                onClick={handleSearch}>
                Search
              </Button>
              <Button
                style={{ width: isMobile ? "80vw" : 140 }}
                type="default"
                onClick={handleCancel}>
                Reset
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchFilters;
